import React from "react";
import { Icon } from "@iconify/react";

function MinusIcon() {
  return (
    <div>
      <Icon icon="circum:square-minus" color="#ff0118" width="30" height="30" />
    </div>
  );
}

export default MinusIcon;
